module.exports = __webpack_public_path__ + "static/media/danger_board.8b3b3017.webp";